/* The Good Stuff: gratis cadeau (silk scarf) automatisch in de winkelwagen.

   Regels
   - Zit er minstens één product uit de Good Stuff-collectie in de wagen,
     dan zit er precies één cadeau in, hoeveel Good Stuff er ook in zit.
   - Geen Good Stuff-product meer: het cadeau gaat eruit.
   - Is het cadeau op, dan voegen we niets toe.
   - Haalt de klant het cadeau zelf weg, dan komt het in deze sessie niet
     terug. We onthouden dat per winkelwagen (cart.token): na een bestelling
     is er een nieuwe wagen en geldt de actie weer gewoon.

   We kijken na elke wijziging die het thema meldt (toevoegen via PDP,
   quick view of drawer; aantal wijzigen of verwijderen in de drawer) en één
   keer bij het laden van de pagina, voor wijzigingen die elders gebeurden.
   Daarna vraagt het thema de drawer opnieuw op via 'cart:refresh'.

   De prijs van €0 dwingen we hier niet af: dat doet de prijs van het
   cadeauproduct of een automatische korting in Shopify. */
(function () {
	var config = window.tgsGift;
	if (!config || window.tgsGiftInit) return;
	window.tgsGiftInit = true;

	var ids = (config.productIds || []).map(Number);
	var giftProductId = Number(config.giftProductId);
	var giftVariantId = Number(config.giftVariantId);
	var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
	var STORAGE_KEY = 'tgsGift';
	var busy = false;
	var again = false;

	function request(path, body) {
		return fetch(root + path, {
			method: body ? 'POST' : 'GET',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: body ? JSON.stringify(body) : undefined
		}).then(function (response) {
			if (!response.ok) throw new Error(path + ' ' + response.status);
			return response.json();
		});
	}

	/* { token, added, declined } voor de huidige winkelwagen. Zonder
	   sessionStorage (privévenster, geblokkeerd) werkt alles behalve het
	   onthouden van een handmatige verwijdering. */
	function readState(token) {
		var state = null;
		try { state = JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch (e) {}
		if (!state || state.token !== token) state = { token: token, added: false, declined: false };
		return state;
	}

	function saveState(state) {
		try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
	}

	function refreshCart() {
		document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
		// Op de winkelwagenpagina zelf staat geen drawer die ververst.
		if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
	}

	function sync() {
		if (busy) { again = true; return; }
		busy = true;
		request('cart.js').then(function (cart) {
			var state = readState(cart.token);
			var qualifies = cart.items.some(function (item) {
				return item.product_id !== giftProductId && ids.indexOf(item.product_id) !== -1;
			});
			var giftLines = cart.items.filter(function (item) {
				return item.product_id === giftProductId;
			});

			if (qualifies && giftLines.length === 0) {
				// Wij voegden het toe en het is weg terwijl er nog Good Stuff in
				// zit: dat heeft de klant zelf gedaan.
				if (state.added) {
					state.added = false;
					state.declined = true;
				}
				saveState(state);
				if (state.declined || !config.giftAvailable || !giftVariantId) return null;

				var properties = {};
				properties[config.lineLabel] = config.lineValue;
				properties._tgs_gift = '1';
				return request('cart/add.js', {
					items: [{ id: giftVariantId, quantity: 1, properties: properties }]
				}).then(function () {
					state.added = true;
					saveState(state);
					refreshCart();
				});
			}

			if (!qualifies && giftLines.length) {
				var updates = {};
				giftLines.forEach(function (line) { updates[line.key] = 0; });
				return request('cart/update.js', { updates: updates }).then(function () {
					state.added = false;
					saveState(state);
					refreshCart();
				});
			}

			if (giftLines.length) {
				state.added = true;
				saveState(state);
			}

			// Precies één cadeau: extra regels of een hoger aantal terugzetten.
			if (qualifies && (giftLines.length > 1 || giftLines[0].quantity > 1)) {
				var fix = {};
				giftLines.forEach(function (line, index) { fix[line.key] = index === 0 ? 1 : 0; });
				return request('cart/update.js', { updates: fix }).then(refreshCart);
			}
			return null;
		}).catch(function (error) {
			console.warn('[tgs-gift]', error);
		}).finally(function () {
			busy = false;
			if (again) { again = false; sync(); }
		});
	}

	document.addEventListener('cart:item-added', sync);
	document.addEventListener('line-item:change:end', sync);

	// Bij laden alleen als er al een winkelwagen is.
	if (document.cookie.indexOf('cart=') !== -1) {
		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
		else sync();
	}
})();
